<template>
  <Timepicker
    input-class="time-input" manual-input
    input-width="80px"
    :format="timeFormat" v-model="selected"
    :minute-interval="minuteInterval"
  />
</template>

<script lang="ts">
import moment, { Moment } from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'
// @ts-expect-error 型チェック不要部分
import Timepicker from 'vue2-timepicker/src'

@Component({
  components: {
    Timepicker,
  },
})
export default class TimeInput extends Vue {
  @Prop() value!: Moment

  @Prop() minuteInterval?: number

  timeFormat: string = 'HH:mm'

  private get selected(): string {
    return this.value ? this.value.format(this.timeFormat) : ''
  }

  private set selected(time: string) {
    const t = (time) ? moment(time.replace(/HH|mm/g, '00'), this.timeFormat) : null
    this.$emit('input', t)
  }
}
</script>

<style>
input.display-time.time-input {
  height: auto;
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
